import { ipsos, supuesto } from ".";

// Lámina 102 (laboral) y lámina 94 (personal), base 400.
// "Ninguna" y "No tiene marca(s)" se omiten a propósito en las listas de marcas: no son marcas.
const P_FRECUENCIA_LAB = "¿Con qué frecuencia compra ropa de trabajo?";
const P_MARCA_LAB = "¿Cuál es su marca de ropa de trabajo preferida?";
const P_DONDE_LAB = "¿Dónde compra su ropa de trabajo?";
const P_CANAL_LAB = "¿Qué canal prefiere para comprar ropa de trabajo?";
const P_TIPO_LAB = "¿Qué tipo de vestimenta usa para trabajar?";
const P_FRECUENCIA_PER = "¿Con qué frecuencia compra ropa personal?";
const P_MARCA_PER = "¿Cuál es su marca de ropa personal preferida?";
const P_DONDE_PER = "¿Dónde compra su ropa personal?";
const P_CANAL_PER = "¿Qué canal prefiere para comprar ropa personal?";

// factor = compras/año (supuesto comercial derivado de la etiqueta de frecuencia Ipsos)
export const IPSOS_VESTIMENTA = {
  laboral: {
    frecuenciaCompra: {
      semanal: {
        pct: ipsos(0.018, { lamina: 102, pregunta: P_FRECUENCIA_LAB, base: 400 }),
        factor: supuesto(52, { nota: "compras/año" }),
        label: "Semanalmente",
      },
      mensual: {
        pct: ipsos(0.398, { lamina: 102, pregunta: P_FRECUENCIA_LAB, base: 400 }),
        factor: supuesto(12, { nota: "compras/año" }),
        label: "Mensualmente",
      },
      trimestral: {
        pct: ipsos(0.257, { lamina: 102, pregunta: P_FRECUENCIA_LAB, base: 400 }),
        factor: supuesto(4, { nota: "compras/año" }),
        label: "Trimestralmente",
      },
      semestral: {
        pct: ipsos(0.214, { lamina: 102, pregunta: P_FRECUENCIA_LAB, base: 400 }),
        factor: supuesto(2, { nota: "compras/año" }),
        label: "Semestralmente",
      },
      anual: {
        pct: ipsos(0.097, { lamina: 102, pregunta: P_FRECUENCIA_LAB, base: 400 }),
        factor: supuesto(1, { nota: "compras/año" }),
        label: "Anualmente",
      },
      noCompra: {
        pct: ipsos(0.015, { lamina: 102, pregunta: P_FRECUENCIA_LAB, base: 400 }),
        factor: supuesto(0, { nota: "no compra" }),
        label: "No compra",
      },
    },
    marcas: {
      "H&M": ipsos(0.242, { lamina: 102, pregunta: P_MARCA_LAB, base: 400 }),
      Zara: ipsos(0.155, { lamina: 102, pregunta: P_MARCA_LAB, base: 400 }),
      Arrow: ipsos(0.064, { lamina: 102, pregunta: P_MARCA_LAB, base: 400 }),
      Io: ipsos(0.064, {
        lamina: 102,
        pregunta: P_MARCA_LAB,
        base: 400,
        nota: "rótulo 'Otros' en la fuente, corregido",
      }),
      Tommy: ipsos(0.048, { lamina: 102, pregunta: P_MARCA_LAB, base: 400 }),
      Levis: ipsos(0.048, { lamina: 102, pregunta: P_MARCA_LAB, base: 400 }),
      Docker: ipsos(0.045, { lamina: 102, pregunta: P_MARCA_LAB, base: 400 }),
      Polo: ipsos(0.038, { lamina: 102, pregunta: P_MARCA_LAB, base: 400 }),
    },
    dondeCompra: {
      "Centros comerciales": ipsos(0.931, { lamina: 102, pregunta: P_DONDE_LAB, base: 400 }),
      "Centro de la ciudad": ipsos(0.088, { lamina: 102, pregunta: P_DONDE_LAB, base: 400 }),
      "Extranjero vía web": ipsos(0.045, { lamina: 102, pregunta: P_DONDE_LAB, base: 400 }),
      "Página web": ipsos(0.025, { lamina: 102, pregunta: P_DONDE_LAB, base: 400 }),
      "No compra": ipsos(0.015, { lamina: 102, pregunta: P_DONDE_LAB, base: 400 }),
    },
    canalPreferido: {
      "Tiendas físicas": ipsos(0.816, { lamina: 102, pregunta: P_CANAL_LAB, base: 400 }),
      Online: ipsos(0.184, { lamina: 102, pregunta: P_CANAL_LAB, base: 400 }),
    },
    tipoVestimenta: {
      Casual: ipsos(0.69, { lamina: 102, pregunta: P_TIPO_LAB, base: 400 }),
      Formal: ipsos(0.299, { lamina: 102, pregunta: P_TIPO_LAB, base: 400 }),
      Uniforme: ipsos(0.026, { lamina: 102, pregunta: P_TIPO_LAB, base: 400 }),
    },
  },
  personal: {
    frecuenciaCompra: {
      semanal: {
        pct: ipsos(0.027, { lamina: 94, pregunta: P_FRECUENCIA_PER, base: 400 }),
        factor: supuesto(52, { nota: "compras/año" }),
        label: "Semanalmente",
      },
      mensual: {
        pct: ipsos(0.536, { lamina: 94, pregunta: P_FRECUENCIA_PER, base: 400 }),
        factor: supuesto(12, { nota: "compras/año" }),
        label: "Mensualmente",
      },
      trimestral: {
        pct: ipsos(0.216, { lamina: 94, pregunta: P_FRECUENCIA_PER, base: 400 }),
        factor: supuesto(4, { nota: "compras/año" }),
        label: "Trimestralmente",
      },
      semestral: {
        pct: ipsos(0.144, { lamina: 94, pregunta: P_FRECUENCIA_PER, base: 400 }),
        factor: supuesto(2, { nota: "compras/año" }),
        label: "Semestralmente",
      },
      anual: {
        pct: ipsos(0.077, { lamina: 94, pregunta: P_FRECUENCIA_PER, base: 400 }),
        factor: supuesto(1, { nota: "compras/año" }),
        label: "Anualmente",
      },
    },
    marcas: {
      "H&M": ipsos(0.164, { lamina: 94, pregunta: P_MARCA_PER, base: 400 }),
      Zara: ipsos(0.125, { lamina: 94, pregunta: P_MARCA_PER, base: 400 }),
      Levis: ipsos(0.122, { lamina: 94, pregunta: P_MARCA_PER, base: 400 }),
      Io: ipsos(0.056, {
        lamina: 94,
        pregunta: P_MARCA_PER,
        base: 400,
        nota: "rótulo 'Otros' en la fuente, corregido",
      }),
      "American Eagle": ipsos(0.053, { lamina: 94, pregunta: P_MARCA_PER, base: 400 }),
      Falabella: ipsos(0.048, { lamina: 94, pregunta: P_MARCA_PER, base: 400 }),
      Sibilla: ipsos(0.046, { lamina: 94, pregunta: P_MARCA_PER, base: 400 }),
      Fiorucci: ipsos(0.045, {
        lamina: 94,
        pregunta: P_MARCA_PER,
        base: 400,
        nota: "rótulo 'Otros' en la fuente, corregido",
      }),
    },
    dondeCompra: {
      "Centros comerciales": ipsos(0.906, { lamina: 94, pregunta: P_DONDE_PER, base: 400 }),
      "Centro de la ciudad": ipsos(0.115, { lamina: 94, pregunta: P_DONDE_PER, base: 400 }),
      "Extranjero vía web": ipsos(0.096, { lamina: 94, pregunta: P_DONDE_PER, base: 400 }),
      "Sitios web": ipsos(0.03, { lamina: 94, pregunta: P_DONDE_PER, base: 400 }),
    },
    canalPreferido: {
      "Tiendas físicas": ipsos(0.721, { lamina: 94, pregunta: P_CANAL_PER, base: 400 }),
      Online: ipsos(0.279, { lamina: 94, pregunta: P_CANAL_PER, base: 400 }),
    },
  },
};

// Supuestos comerciales (CLP)
export const TICKETS_VESTIMENTA = [
  supuesto(30000, { nota: "ticket promedio" }),
  supuesto(50000, { nota: "ticket promedio" }),
  supuesto(75000, { nota: "ticket promedio" }),
  supuesto(100000, { nota: "ticket promedio" }),
];

export const ESCENARIOS_CAPTACION_VESTIMENTA = [
  supuesto(2, { nota: "escenario de captación de mercado" }),
  supuesto(4, { nota: "escenario de captación de mercado" }),
  supuesto(6, { nota: "escenario de captación de mercado" }),
  supuesto(8, { nota: "escenario de captación de mercado" }),
  supuesto(10, { nota: "escenario de captación de mercado" }),
];
